
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 8v3M12 9.5h3M5 2.5v3M3.5 4h3M10.5 11.5v2M9.5 12.5h2M9 5l2 2M11.353 2.646l-8.707 8.707a.5.5 0 000 .708l1.293 1.292a.5.5 0 00.707 0l8.707-8.707a.5.5 0 000-.707L12.06 2.646a.5.5 0 00-.707 0z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    